import { useMemo, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Checkbox } from "../components/ui/checkbox";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Copy, DollarSign, Mail, Phone, Plus, User } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../components/ui/dialog";

const ReferralCard = () => {
  const { fullName, email, phone, planOption } = useMemo(() => {
    try {
      const raw = localStorage.getItem("bv.registerResponse");
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return {
        fullName: parsed?.fullName || parsed?.user?.fullName,
        email: parsed?.email || parsed?.user?.email,
        phone: parsed?.phone || parsed?.user?.phone,
        planOption: parsed?.planOption || parsed?.user?.planOption,
      };
    } catch {
      return {};
    }
  }, []);

  const REFERRAL_LINK = `bizvantage.com/ref/${email || "user"}`;
  const REFERRAL_FEE = "$500";

  const [referrals, setReferrals] = useState([
    {
      id: "1",
      name: fullName || "Your Name",
      company: planOption ? `${planOption} Plan` : "BizVantage",
      email: email || "you@example.com",
      phone: phone || "(000) 000-0000",
      contacted: false,
    },
  ]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newReferral, setNewReferral] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
  });

  const toggleContacted = (id) => {
    setReferrals((prev) =>
      prev.map((r) => (r.id === id ? { ...r, contacted: !r.contacted } : r)),
    );
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(`https://${REFERRAL_LINK}`);
    toast.success("Referral link copied to clipboard!");
  };

  const handleAddReferral = () => {
    if (!newReferral.name.trim()) return;
    setReferrals((prev) => [
      ...prev,
      { ...newReferral, id: String(Date.now()), contacted: false },
    ]);
    setNewReferral({ name: "", company: "", email: "", phone: "" });
    setDialogOpen(false);
    toast.success("Referral added!");
  };

  return (
    <Card className="shadow-[var(--card-shadow)]">
      <CardHeader>
        <CardTitle className="text-lg font-display">Referral</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <h3 className="text-center">Coming Soon</h3>
          {/* Referral Fee */}
          {/* <div className="flex items-center gap-2 rounded-md bg-primary/5 border border-primary/20 px-3 py-2">
            <DollarSign className="h-4 w-4 text-primary" />
            <span className="text-sm font-medium">
              Earn {REFERRAL_FEE} per successful referral
            </span>
          </div> */}

          {/* Referral Link */}
          {/* <div className="flex items-center gap-2 rounded-md border bg-muted/30 px-3 py-2">
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-0.5">
                Your referral link
              </p>
              <p className="text-sm font-medium truncate">{REFERRAL_LINK}</p>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="h-7 w-7 shrink-0"
              onClick={handleCopyLink}
            >
              <Copy className="h-3.5 w-3.5" />
            </Button>
          </div> */}

          {/* Referral List */}
          {/* <div className="space-y-1">
            {referrals.map((ref) => (
              <div
                key={ref.id}
                className="rounded-md border px-3 py-2.5 space-y-1.5"
              >
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={ref.contacted}
                    onCheckedChange={() => toggleContacted(ref.id)}
                    id={`contacted-${ref.id}`}
                  />
                  <label
                    htmlFor={`contacted-${ref.id}`}
                    className="text-sm font-medium cursor-pointer flex-1"
                  >
                    {ref.name}
                  </label>
                  <span className="text-[10px] text-muted-foreground">
                    {ref.contacted ? "Contacted" : "Not contacted"}
                  </span>
                </div>
                <div className="pl-6 space-y-0.5">
                  <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                    <User className="h-3 w-3" />
                    {ref.company}
                  </p>
                  <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                    <Mail className="h-3 w-3" />
                    {ref.email}
                  </p>
                  <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                    <Phone className="h-3 w-3" />
                    {ref.phone}
                  </p>
                </div>
              </div>
            ))}
          </div> */}

          {/* Add Referral Button */}
          {/* <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            <DialogTrigger asChild>
              <Button variant="outline" size="sm" className="w-full text-xs">
                <Plus className="h-3.5 w-3.5 mr-1" />
                Add Referral
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle className="font-display">Add Referral</DialogTitle>
              </DialogHeader>
              <div className="space-y-3 pt-2">
                <div className="space-y-1">
                  <Label>Name</Label>
                  <Input
                    value={newReferral.name}
                    onChange={(e) =>
                      setNewReferral((p) => ({ ...p, name: e.target.value }))
                    }
                  />
                </div>
                <div className="space-y-1">
                  <Label>Company</Label>
                  <Input
                    value={newReferral.company}
                    onChange={(e) =>
                      setNewReferral((p) => ({ ...p, company: e.target.value }))
                    }
                  />
                </div>
                <div className="space-y-1">
                  <Label>Email</Label>
                  <Input
                    type="email"
                    value={newReferral.email}
                    onChange={(e) =>
                      setNewReferral((p) => ({ ...p, email: e.target.value }))
                    }
                  />
                </div>
                <div className="space-y-1">
                  <Label>Phone</Label>
                  <Input
                    type="tel"
                    value={newReferral.phone}
                    onChange={(e) =>
                      setNewReferral((p) => ({ ...p, phone: e.target.value }))
                    }
                  />
                </div>
                <Button
                  className="w-full"
                  onClick={handleAddReferral}
                  disabled={!newReferral.name.trim()}
                >
                  Add Referral
                </Button>
              </div>
            </DialogContent>
          </Dialog> */}
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralCard;
